(() => {
  const config = document.querySelector('script[data-vanoir-checkout]');
  if (!config || window.vanoirBrandedCheckout) return;
  window.vanoirBrandedCheckout = true;
  const checkout = new URL(config.dataset.vanoirCheckout);
  if (checkout.protocol !== 'https:' || checkout.hostname !== `checkout.${location.hostname.replace(/^www\./, '')}`) return;
  const cartUrl = config.dataset.cartUrl;
  const cartSelectors = '[name="checkout"],#checkout,.cart__checkout-button,[data-action="checkout"],[data-rebuy-checkout],.upcart-checkout-button-container a,.ocu-checkout-button,.ocu-checkout-button-new,#mu-checkout-button,#kaching-cart__checkout-button,.kaching-cart__checkout-button';
  const buySelectors = '[name="buy_it_now"],.shopify-payment-button,.product__buy-now,[data-action="buy-now"],[data-pf-type="ProductCheckout"],[data-gem-action="buy-now"],[data-rebuy-buy-now]';
  const trackingKeys = ['affId','affid','c1','c2','c3','c4','c5','utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid','ttclid','trafficSource'];
  const incoming = new URLSearchParams(location.search);
  let tracking = new URLSearchParams();
  try { tracking = new URLSearchParams(sessionStorage.getItem('vanoir_cc_attribution') || ''); } catch {}
  for (const key of trackingKeys) if (incoming.has(key)) tracking.set(key,incoming.get(key));
  try { sessionStorage.setItem('vanoir_cc_attribution',tracking.toString()); } catch {}
  let busy = false;
  const reportError = () => {
    let status = document.getElementById('vanoir-checkout-error');
    if (!status) {
      status = document.createElement('p');
      status.id = 'vanoir-checkout-error';
      status.setAttribute('role', 'alert');
      status.tabIndex = -1;
      (document.querySelector('main') || document.body).prepend(status);
    }
    status.textContent = config.dataset.error;
    status.focus();
  };
  const getDestination = async () => {
    const response = await fetch(`${cartUrl}?section_id=vanoir-cc-cart`, {credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error('Cart unavailable');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const cart = JSON.parse(html.querySelector('#vanoir-cc-cart-data').textContent);
    if (!cart.items.length || cart.currency !== 'USD') throw new Error('Cart not ready');
    let sum = 0;
    const products = cart.items.map(item => {
      if (!/^\d+(\.\d+)?$/.test(item.product) || !Number.isInteger(item.quantity) || item.quantity < 1 || item.price !== item.base_price) throw new Error('Cart mapping mismatch');
      sum += item.price * item.quantity;
      return `${item.product}:${item.quantity}`;
    });
    if (sum !== cart.total) throw new Error('Cart discount requires review');
    const destination = new URL(checkout);
    destination.searchParams.set('products', products.join(';'));
    destination.searchParams.set('c', cart.currency);
    for (const key of trackingKeys) if (tracking.has(key)) destination.searchParams.set(key,tracking.get(key));
    return destination.href;
  };
  const run = async (button, buyNow) => {
    if (busy) return;
    busy = true;
    button?.setAttribute('aria-busy','true');
    try {
      if (buyNow) {
        const form = button.closest('form[action*="/cart/add"]') || (button.getAttribute('form') && document.getElementById(button.getAttribute('form')));
        if (!form || !form.reportValidity()) return;
        const data = new FormData(form);
        if (!data.get('id')) throw new Error('Missing selected variant');
        const response = await fetch(`${config.dataset.cartAddUrl}.js`, {method:'POST',credentials:'same-origin',body:data,signal:AbortSignal.timeout(15000)});
        if (!response.ok) throw new Error('Unable to add product');
      }
      location.assign(await getDestination());
    } catch (error) {
      console.warn('Branded checkout handoff stopped:', error.message);
      reportError();
    } finally {
      busy = false;
      button?.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('click', event => {
    const path = event.composedPath().filter(el => el instanceof Element);
    const button = path.find(el => el.matches(cartSelectors) || (el.matches('a[href]') && /^\/checkout(?:[/?#]|$)/.test(el.getAttribute('href'))));
    const buyNow = button ? null : path.find(el => el.matches(buySelectors));
    if (!button && !buyNow) return;
    if ((button || buyNow).disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    run(button || buyNow, Boolean(buyNow));
  },true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (event.submitter?.matches(buySelectors)) {
      event.preventDefault(); event.stopImmediatePropagation(); run(event.submitter,true);
    } else if (event.submitter?.matches(cartSelectors) || /\/checkout(?:[/?#]|$)/.test(form.action)) {
      event.preventDefault(); event.stopImmediatePropagation(); run(event.submitter,false);
    }
  },true);
})();
